import React, { Component } from 'react';

import { Box, Stack } from '@mui/material';

import BookingCancelledToggle from './BookingCancelledToggle';
import TourCancellationWarning from './TourCancellationWarning';

export default class FraudAndComplianceAndDisputeContainer extends Component {
  render() {
    const shouldDisallowTourCancellation =
      this.props.refund.is_tour && this.props.refund.is_tour_with_active_optional_extras;

    return (
      <Box id="FraudAndComplianceAndDisputeContainer">
        <Stack direction="row" spacing={2}>
          <Box>
            <input
              type="radio"
              key="default"
              name="source"
              value="Default"
              onChange={this.props.handleValueChange}
              checked={this.props.refund.source == 'Default'}
            />
            <label>
              <b>Both LE &amp; Vendor Are liable</b>
            </label>
          </Box>
          <Box>
            <input
              type="radio"
              key="tnfh"
              name="source"
              value="Luxury Escapes (TNFH)"
              onChange={this.props.handleValueChange}
              checked={this.props.refund.source == 'Luxury Escapes (TNFH)'}
            />
            <label>
              <b>Only LE is liable</b>
            </label>
          </Box>
        </Stack>
        <TourCancellationWarning shouldDisallowTourCancellation={shouldDisallowTourCancellation} />
        {!shouldDisallowTourCancellation && !this.props.refund.is_subscription && (
          <BookingCancelledToggle
            handleFlagChange={this.props.handleFlagChange}
            mark_cancelled={this.props.refund.mark_cancelled}
          />
        )}
      </Box>
    );
  }
}
